import { Component, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'video-hero',
  styleUrl: 'video-hero.scss',
  shadow: false,
})
export class VideoHero {
  @Prop() contentType: 'video' | 'image' = 'video';
  @Prop() videoSrc: string = '';
  @Prop() desktopImg: string;
  @Prop() mobileImg: string;
  @Prop() poster: string;
  @Prop() disableAutoplay: boolean = false;

  @State() isPlaying: boolean = false;
  private videoUrl: HTMLVideoElement;

  togglePlayPause() {
    if (this.isPlaying) {
      this.videoUrl.pause();
    } else {
      this.videoUrl.play();
    }
    this.isPlaying = !this.isPlaying;
  }

  componentDidLoad() {
      if(this.videoUrl?.autoplay) {
        this.isPlaying = true;
      }
  }

  renderMedia() {
    if (this.contentType === 'video' && this.videoSrc !== '') {
      return (
        <video ref={(el) => (this.videoUrl = el as HTMLVideoElement)} class="lazy-load-bg" preload="auto" poster={this.poster} playsinline loop muted autoplay={!this.disableAutoplay}>
          <source src={this.videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    } else if (this.contentType === 'image') {
      return (
        <picture>
           {this.mobileImg ? (
              <source media="(max-width: 991px)" srcSet={this.mobileImg} />
            ) : null}
          <img
            src={this.desktopImg}
            alt=""
            role="presentation"
            class="bg-image"
          />
        </picture>
      );
    } else {
      return null; // Render nothing if contentType is neither 'video' nor 'image' or if the necessary props are not provided
    }
  }

  render() {
    return (
      <div class='video-hero-media'>
        {this.renderMedia()}
        {this.contentType === 'video' && this.videoSrc !== '' ? (
          <div class="custom-controls">
            <button 
              class="video-hero-toggle" 
              onClick={() => this.togglePlayPause()} 
              aria-label={this.isPlaying ? 'click here to pause video' : 'click here to play video'}>
              {this.isPlaying ? <kdx-icon icon="pause" class="pause-icon"></kdx-icon> : <kdx-icon icon="play" class="play-icon"></kdx-icon>}
            </button>
          </div>
        ) : null}
        <slot />
      </div>
    );
  }
}

